export default __webpack_public_path__ + "static/media/mPants_1_p3.bd0e3cee.jpeg";